import styled from 'styled-components';
import query from 'syf-component-library/const/mediaQueries';
import Inset from 'syf-component-library/ui/spacing/Inset';
import { H5 } from 'syf-component-library/ui/typography';
import { fontSizes } from 'syf-component-library/defaultTheme';
import PaymentSecurityDebtCancellation from '../../../../common/payment-debt-cancellation';
export const DebtCancellationContainer = styled(PaymentSecurityDebtCancellation) `
  margin-top: auto;
  text-align: left;
  padding-top: 96px;
`;
export const Image = styled.img `
  height: auto;
  width: 100%;
  margin: 0 auto;
  max-width: 134px;

  @media ${query.lessThanSmall} {
    max-width: 115px;
  }
`;
export const SuccessMessageContainer = styled(Inset) `
  display: flex;
  flex-direction: column;
  height: 100%;
  align-self: center;
  max-width: 672px;
  width: 90%;
  text-align: center;
`;
export const TitleContainer = styled(H5) `
  line-height: 28px;

  @media ${query.lessThanSmall} {
    font-size: ${fontSizes.medium}px;
  }
`;
